import { reactive } from "vue";
import { useStore } from "vuex";
import { RECOVER_HISTORY } from "../store/modules/survey/actions";
import { useRouter } from "vue-router";
export const popupState = reactive({
  history: false, // 是否有历史记录
  tips: "", // 当前tips，若有内容则展示弹窗
  currentYoutubeLink: "", // 当前youtube链接，如有内容则展示弹窗
});

export const hidePopup = () => {
  popupState.history = false;
  popupState.tips = "";
  popupState.currentYoutubeLink = "";
};
export const showPopup = (type) => {
  popupState[type] = true;
};
export const showTipsPopup = (tips = "") => {
  popupState.tips = tips;
};
export const showYoutubePopup = (link) => {
  // 区分标准链接格式及短链接格式
  const reg =
    /(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([\w-]{11})/;
  const match = link.match(reg);
  const embedLink = match ? match[1] : "";
  popupState.currentYoutubeLink = embedLink;
};
export default function () {
  const router = useRouter();
  const store = useStore();
  const recoverData = () => {
    store.dispatch(`survey/${RECOVER_HISTORY}`);
    popupState.history = false;
    router.push({
      name: "question",
    });
  };
  return {
    popupState,
    hidePopup,
    showPopup,
    recoverData,
  };
}
